module.exports = __webpack_public_path__ + "static/media/template-based.e0a1c795.jpg";